/* eslint-disable */
import {
	DIMENSION,
	ANOMALY_TABLE_SALES_METRICS,
	ROOT_CAUSES,
	CHANNEL,
} from '../constants';
import { generateAnomalyDetectionQuery } from '../queries/guided-Insights/anomaly-detection/anomaly-detection-query';
import { generateSalesQuery } from '../queries/metrics/sales-query-copy';
import { generateRootCauseQuery } from '../queries/guided-Insights/root-cause-analysis/root-cause-query';
import { transformSupplierShareResponse } from '../transformers/transform-supplier-share-response';
import { generateReplInStockPctQuery } from '../queries/guided-Insights/root-cause-analysis/edit-replenishment-instock-pct-query';
import {
	generateFederatedMetricsQuery,
	getAttributeIds,
	retriveAttributeIds,
	concatAnomaliesWithSalesResponse,
	concatRootCauseWithMetricsResponse,
	retrieveWmItemNbrs,
	transformRCAResponse,
	getWmtItemNrbs,
	updateRootCauseDetails,
	concatInventoryRootCauseWithMetrics,
	createAnomalyDetectionResponse,
	setWmItemNbrs,
} from '../util';
import { call, put } from 'redux-saga/effects';
import {
	getAnomalyDetectionDataFailure,
	getAnomalyDetectionDataSuccess,
	getAnomaliesSalesMetricsSuccess,
	getAnomaliesSalesMetricsFailure,
} from '../../../actions/anomalyDetectionActions';
import {
	getRcaDataSuccess,
	getRcaBDDMetricsSuccess,
	getRcaDataFailure,
	getRcaBDDMetricsFailure,
	updateInventoryRootCauseSuccess,
	updateInventoryRootCauseFailure,
	updateInventoryRootCauseNoDataSuccess,
} from '../../../actions/rcaActions';

import { updateFederatedMetricsQuery } from '../update-root-cause-query';

export function* getAnomalyDetectionData(action) {
	const payload = action?.payload?.payload;
	try {
		const anomalyDetectionResponse = yield call(
			generateAnomalyDetectionQuery,
			payload
		);
		const { marketShare, anomalySummary } = anomalyDetectionResponse.data;
		let supplierShareResponse;
		if (marketShare) {
			supplierShareResponse = transformSupplierShareResponse(marketShare);
		}
		const deptIds = retriveAttributeIds(anomalySummary.anomalies, 'DEPARTMENT');
		if (deptIds.length > 0) {
			const salesMetricsResponse = yield call(
				generateSalesQuery,
				ANOMALY_TABLE_SALES_METRICS,
				DIMENSION.DEPARTMENT,
				deptIds,
				payload
			);
			if (salesMetricsResponse?.data?.federatedMetricValues?.sales) {
				const response = createAnomalyDetectionResponse(
					anomalySummary,
					salesMetricsResponse?.data,
					supplierShareResponse
				);
				yield put(getAnomalyDetectionDataSuccess(response));
			} else {
				yield put(getAnomalyDetectionDataFailure('error'));
			}
		} else {
			const response = createAnomalyDetectionResponse(
				anomalySummary,
				{},
				supplierShareResponse
			);
			yield put(getAnomalyDetectionDataSuccess(response));
		}
	} catch (error) {
		yield put(getAnomalyDetectionDataFailure('error'));
	}
}

export function* getAnomaliesSalesMetrics(action) {
	const { attribute, anomalies, request, anomaly, filterAnomaly } =
		action.payload;
	try {
		const attributeIds = getAttributeIds(anomalies);
		const salesMetricsResponse = yield call(
			generateSalesQuery,
			ANOMALY_TABLE_SALES_METRICS,
			DIMENSION[attribute],
			attributeIds,
			request
		);
		const dimension = DIMENSION[attribute];
		const updatedAnomalies = concatAnomaliesWithSalesResponse(
			anomalies,
			salesMetricsResponse?.data.federatedMetricValues.sales,
			dimension
		);
		const salesMetricsDict = {
			tableRows: updatedAnomalies,
			hierarchyLevel: attribute,
		};
		yield put(getAnomaliesSalesMetricsSuccess(salesMetricsDict));
		if (anomaly) filterAnomaly(anomaly);
	} catch (error) {
		yield put(getAnomaliesSalesMetricsFailure('error'));
	}
}

export function* getRootCausesData(action) {
	const { request } = action?.payload;
	try {
		const rootCausesResponse = yield call(generateRootCauseQuery, request);

		const { rootCause, id, marketShare, marketShareChng, name } =
			rootCausesResponse.data.anomaly;
		const rootCauses = transformRCAResponse(
			rootCausesResponse?.data?.anomaly?.rootCause,
			request.anomalyChange
		);
		const rootCauseDict = rootCauses[0];
		const wmItemNbrs = retrieveWmItemNbrs(rootCauseDict.details.edges);
		const currentRootCause = rootCauseDict?.domain;
		const updatedRootCausesResponse = {
			id: id,
			marketShare: marketShare,
			marketShareChng: marketShareChng,
			name: name,
			rootCauses: rootCauses,
		};
		let concatResponseObj = {};
		const payload = {
			ids: wmItemNbrs,
			channel: [CHANNEL.STORE],
			dimension: DIMENSION[request.type],
			...request,
		};
		const federatedMetricsResponse = yield call(
			generateFederatedMetricsQuery,
			currentRootCause,
			true,
			payload
		);
		concatResponseObj = concatRootCauseWithMetricsResponse(
			currentRootCause,
			true,
			updatedRootCausesResponse,
			federatedMetricsResponse.data
		);
		const obj = {
			concatResponseObj: concatResponseObj,
			highestRootCause: currentRootCause,
		};

		yield put(getRcaDataSuccess(obj));
	} catch (error) {
		yield put(getRcaDataFailure('error'));
	}
}

export function* getRootCauseMetricsData(action) {
	const { request, rootCause, rootCauses } = action?.payload;
	try {
		const currentRootCause = rootCauses.filter((obj) => {
			if (obj?.domain == rootCause) {
				return obj;
			}
		});
		const wmItemNbrs = getWmtItemNrbs(currentRootCause);
		const payload = {
			ids: wmItemNbrs,
			...request,
		};
		const threshold = ['95'];
		const federatedMetricsResponse = yield call(
			updateFederatedMetricsQuery,
			rootCause,
			payload,
			threshold
		);
		const rootCauseMetricsObj = updateRootCauseDetails(
			federatedMetricsResponse,
			rootCause
		);
		yield put(getRcaBDDMetricsSuccess(rootCauseMetricsObj));
	} catch (error) {
		yield put(getRcaBDDMetricsFailure('error'));
	}
}

export function* getInventoryRootCauseData(action) {
	const { request } = action?.payload;
	try {
		const rootCausesResponse = yield call(generateReplInStockPctQuery, request);
		const wmItemNbrs = setWmItemNbrs(
			rootCausesResponse.data.inventoryHealth?.causes.edges
		);
		if (wmItemNbrs.length) {
			let federatedMetricsReq = {
				ids: wmItemNbrs,
				...request,
				channel: ['STORE'],
			};
			const threshold = request.threshold;
			const federatedMetricsResponse = yield call(
				updateFederatedMetricsQuery,
				ROOT_CAUSES.INVENTORY_HEALTH,
				federatedMetricsReq,
				threshold
			);
			const rootCausesList = transformRCAResponse(rootCausesResponse.data);
			const updatedRootCausesResponse = {
				rootCauses: rootCausesList,
			};
			const updatedRootCauseObj = concatInventoryRootCauseWithMetrics(
				federatedMetricsResponse.data,
				updatedRootCausesResponse
			);
			yield put(updateInventoryRootCauseSuccess(updatedRootCauseObj));
		} else {
			yield put(updateInventoryRootCauseNoDataSuccess());
		}
	} catch (error) {
		yield put(updateInventoryRootCauseFailure('error'));
	}
}
